export enum CheckoutSteps {
  yourInfo = 'yourInfo',
  verification = 'verification',
  extras = 'extras',
  payment = 'payment',
}
